module.exports = __webpack_public_path__ + "static/media/selo-diaadia.629961dc.png";